// =======================================================
// Search
// =======================================================
// Variables
const tools      = document.querySelector('#js-tools')
const searchpage = document.querySelector('body.search');
const searchTool = tools.querySelector('#js-toolSearch');
const searchPopup = document.querySelector('.search-popup');
const searchInput = document.querySelector('#searchInput');
const searchClose = document.querySelector('.search-close');

if (!searchpage) {
    searchClose.setAttribute('tabindex', -1);
    searchInput.setAttribute('tabindex', -1);
}

// Event click
searchTool.addEventListener('click', function() {
    document.body.classList.add('search-open');
    searchPopup.classList.remove('hideX');
    searchPopup.classList.add('showX');
    document.querySelector('.searchInput').focus()
    searchClose.setAttribute('tabindex', 0);
    searchInput.setAttribute('tabindex', 0);
})

if (searchPopup) {
    if (searchClose) {
        searchClose.addEventListener('click', function () {
            document.body.classList.remove('search-open');
            searchPopup.classList.add('hideX');
            searchPopup.classList.remove('showX');
            this.setAttribute('tabindex', -1);
            searchInput.setAttribute('tabindex', -1);
        })
    }
}


// =======================================================
// Google Translate
// =======================================================
// Function eventFire
// function eventFire(el, etype){
//     if (el.fireEvent) {
//         el.fireEvent('on' + etype);
//     } else {
//         let evObj = document.createEvent('Events');
//         evObj.initEvent(etype, true, false);
//         el.dispatchEvent(evObj);
//     }
// }
// // Variable
// const translateBtn = tools.querySelector('#js-toolTranslate');

// // Event click
// if (translateBtn) {
//     !!translateBtn && translateBtn.addEventListener('click', function() {
//         let googleGadget = document.querySelector('#google_translate_element .skiptranslate .goog-te-gadget-simple');
    
//         eventFire(googleGadget, 'click');
    
//         return false;
//     })
// }

window.addEventListener("load", () => {
    // console.log("page is fully loaded");

    // Variable
    const body  = document.body;
    const home  = body.classList.contains('home');

    const toolsTranslate      = tools.querySelector('#js-toolsTranslate')
    const translateBtn        = tools.querySelector('#js-toolTranslate--custom');
    const translateclose      = tools.querySelector('#js-toolTranslate--close');
    const translateWrapper    = tools.querySelector('.gtranslate_wrapper');
    const translatelinks      = tools.querySelectorAll('.gtranslate_wrapper a.glink');
    const translateGoogle     = tools.querySelector('#google_translate_element2');
    

    if (translateBtn) {

        translateWrapper.insertBefore(translateclose, translateGoogle);

        !!translateBtn && translateBtn.addEventListener('click', function() {
            translateWrapper.classList.toggle('open');
            body.classList.toggle('js-active-navmain');
            //console.log("ouvre ou ferme le wrapper stp");

            if (home) {
                // Close Access
                let home      = document.querySelector('.front-page');
                let access    = document.querySelector('.access');
                access.classList.remove('access-js-active');
                home.classList.remove('js-active');
                // console.log("enleve les acces");
            }
        })
    
        translatelinks.forEach(function (translatelink) {
            //console.log("tes ou");
    
            translatelink.addEventListener('click', function() {
                this.parentElement.classList.remove('open');
                body.classList.remove('js-active-navmain');
                //console.log("referme le wrapper stp");
            })
        });

        translateclose.addEventListener('click', function() {
            translateWrapper.classList.remove('open');
            body.classList.remove('js-active-navmain');
        })

        document.addEventListener("mouseup", function(event) {
            if (!toolsTranslate.contains(event.target)) {
                translateWrapper.classList.remove('open');
                body.classList.remove('js-active-navmain');
            }
        });
    }

});


// =======================================================
// Profils
// =======================================================
// Variable
const profileBtn = tools.querySelector('#js-toolProfile');

// Event click
if (profileBtn) {
    !!profileBtn && profileBtn.addEventListener('click', function() {
        profileBtn.closest('.header').querySelector('.tools-view .profils').classList.toggle('show-list');
    })
}


// =======================================================
// Favorite
// =======================================================
// // Variable
// const favoriteBtn = tools.querySelector('#js-toolFavorite');
// // Event click
// if (favoriteBtn) {
//     !!favoriteBtn && favoriteBtn.addEventListener('click', function() {
//         favoriteBtn.closest('.header').querySelector('.tools-view #divFavorites').classList.toggle('show-list');
//     })
// }


// =======================================================
// Quick Access
// =======================================================
// Variable
const accessBtn = document.querySelector('.quick-access__title');

// Event click
if (accessBtn) {
    !!accessBtn && accessBtn.addEventListener('click', function() {
        accessBtn.closest('.quick-access').classList.toggle('open');
    })
}
